import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=bd8c1cc4&scoped=true"
import script from "./attachment.vue?vue&type=script&lang=js"
export * from "./attachment.vue?vue&type=script&lang=js"
import style0 from "./attachment.vue?vue&type=style&index=0&id=bd8c1cc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8c1cc4",
  null
  
)

export default component.exports